export default {
  name: 'Phoenix Global Forum',
  shortName: 'Phoenix',
  description:
    'The Phoenix Global Forum is hosted by the IEFA and Phoenix Sister Cities. As the fastest growing city in the US, Phoenix is quickly emerging as a hub for the biosciences, technology, sustainability and defense sectors, which is attracting major outside investment to the region and creating a burgeoning business ecosystem.',
  thumbnail: '/images/events/phoenix/thumbnail-phoenix.jpg',
  link: 'https://www.phoenixglobalforum.com/',
  header: {
    content:
      'The Phoenix Global Forum is hosted by the IEFA and Phoenix Sister Cities. As the fastest growing city in the US, Phoenix is quickly emerging as a hub for the biosciences, technology, sustainability and defense sectors, which is attracting major outside investment to the region and creating a burgeoning business ecosystem.'
  },
  bullets: {
    bullet1: {
      number: '1',
      label: 'Edition'
    },
    bullet2: {
      number: '0',
      label: 'In-Person Participants'
    },
    bullet3: {
      number: '0',
      label: 'Speakers'
    },
    bullet4: {
      number: '0',
      label: 'Represented Countries'
    }
  },
  about: {
    title: 'Our Purpose',
    content:
      'The Phoenix Global Forum will act as a platform where decision makers, thought leaders and experts in their respective fields convene to discuss society’s evolving needs amidst ongoing global challenges. The forum will examine solutions already in development, both in Phoenix and worldwide, while also fostering future innovation through connection and collaboration.'
  },
  next: {
    title: 'Forging The Future',
    content:
      'The first edition of the Phoenix Global Forum will examine the international cooperation and strategic innovation needed to address emerging global challenges. Decision makers and leaders from the worlds of business, government and academia will convene to discuss these challenges and the subsequent opportunities which can ensure sustained growth and competitiveness. The Phoenix Global Forum will take place on May 2nd, 2024 at the Arizona Biltmore Hotel. '
  },
  gallery: {
    title: 'Photo gallery',
    edition11: {
      title: '11th edition — Investing in Trust',
      index: [
        {
          image: '/images/events/miami/gallery/12th-miami-001.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-002.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-003.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-004.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-005.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-006.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-007.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-008.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-009.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-010.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-011.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-012.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-013.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-014.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-015.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-016.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-017.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-018.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-019.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-020.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-021.jpg'
        }
      ]
    }
  }
}
